"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "morbegno": {
    "5985c56b": [{
      "hkey": "4786c5f9",
      "slug": "morbegno",
      "name": "Morbegno",
      "primary": true,
      "skipSearch": false
    }],
    "campo-erbolo": [{
      "hkey": "4786c5f9",
      "slug": "morbegno",
      "name": "Morbegno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5911e6e7": [{
      "hkey": "df5dc38f",
      "slug": "valle-campoerbolo",
      "name": "Valle-Campoerbolo",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "df5dc38f",
      "slug": "valle-campoerbolo",
      "name": "Valle-Campoerbolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;